<template>
  <section :class="[{ 'no-margin' : screenParams.secondLayout }, style.question]">
    <one-line-form :button="false" class="question">
      <input-field type="text" class="disabled invisible" />
      <h5>{{ screenParams.text() }}</h5>
      <p class="description" v-if="screenParams.description">{{ screenParams.description()}} </p>
    </one-line-form>
    <option-selector 
      v-if="!screenParams.secondLayout" 
      ref="optionSelector" 
      :screenParams="screenParams"
      :options="screenParams.answers($store)" 
      @submit="selectAnswer"/>
    <transition name="bottom" appear>
      <action-bar v-if="screenParams.secondLayout">
        <ul class="columns">
          <li v-for="item in screenParams.answers($store)" :key="item.id" @click="selectAnswer(item)" :class="{saving : isSaving && item.id === answer, primary: !!item.primary}"> {{item.label}} </li>
        </ul>
      </action-bar>
    </transition>
  </section>
</template>

<style lang="scss" rel="stylesheet/scss" scoped>
  @import '../assets/mixins';

  ul {
    @include button-list;
  }

  section.no-margin {
    margin-top: 80px !important;
  }
  input {
    &::-webkit-input-placeholder {
      font-weight: 400;
    }
    &[disabled] {
      color: black;
    }

    border-bottom-color: transparent;
  }

  h5 {
    color: #333333;
    font-size: 24px;
    font-weight: bold;
    letter-spacing: 0;
    white-space: pre-line;
    line-height: 31px;
  }
  p.description {
    color: #3D3D3D;
    font-size: 16px;
    letter-spacing: 0;
    line-height: 19px;
    margin-top: 8px;
    white-space: pre-line;
  }

  .input-wrapper.invisible{
    position: absolute;
  }

  .secondary-buttons-wrapper {
    width: 100%;
    margin-top: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    z-index: 1;
    @include desktop-big {
      margin-bottom: 20px;
    }
    .secondary-btn-option {
      height: 60px;
      width: calc(100% - 10px);
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: bold;
      cursor: pointer;
      background-color: #F4F4F4;
      font-size: 20px;
      border-radius: 4px;
      &:nth-child(2) {
        margin-left: 7px;
      }
      &.selected {
        &.saving {
            color: white;
        }
      }
    }
  }
</style>

<script>
  import Vue from 'vue'

  import Mousetrap from 'mousetrap'

  export default Vue.component('gender-name-screen', {
    
    props: ['screenParams'],
    data () {
      return {
        selectedAnswerIndex: -1,
        answer: this.screenParams.currentAnswer(this.$store),
        visibleQuestion: true,
        isSaving: false
      }
    },
    computed: {
      style () {
        return {
          queston: this.$css(`
            .secondary-btn-option {
              color: ${this.theme.buttonPrimaryColor};
              &.selected {
                background-color: ${this.theme.actionNormalColor} !important;
                &.saving {
                    background-color: ${this.theme.savingTextColor} !important;
                }
              }
            }
          `)
        }
      },
      hint () {
        return this.screenParams.hint ? this.screenParams.hint() : ''
      }
    },
    methods: {
      async selectAnswer (answer) {
        this.answer = answer.id
        this.isSaving = true

        let answerData = {}
        answerData[this.screenParams.propertyName] = this.answer

        await this.$store.dispatch(this.screenParams.dispatchKey, answerData)

        if (this.screenParams && this.screenParams.beforeNextScreenHandler) {
          await this.screenParams.beforeNextScreenHandler(this.$store)
        }

        this.$emit('tooltip', 'hide')

        this.$store.dispatch('next', this.screenParams.nextScreenRoute)
      }
    },
    mounted () {
      const isList = (this.screenParams.answers && this.screenParams.answers(this.$store).length) > 2
      this.$emit('tooltip', isList ? ['vertical', 'enter'] : ['horizontal', 'enter'])

      if (this.screenParams && this.screenParams.secondaryButtonLayout && this.screenParams.answers) {
        const options = this.screenParams.answers(this.$store)
        this.selectedAnswerIndex = options.map(e => e.id).indexOf(this.answer)
  
        Mousetrap.bind(['right', 'down'], () => {
            if (this.selectedAnswerIndex >= options.length - 1) return
            this.selectedAnswerIndex++
            this.answer = options[this.selectedAnswerIndex].id
        })

        Mousetrap.bind(['left', 'up'], () => {
           if (this.selectedAnswerIndex <= 0) return
          this.selectedAnswerIndex--
          this.answer = options[this.selectedAnswerIndex].id
        })

         Mousetrap.bind('enter', () => {
            if (this.selectedAnswerIndex === -1) return
  
            const options = this.screenParams.answers(this.$store)
            this.selectAnswer(options[this.selectedAnswerIndex])
        })
      }
    }
  })
</script>



// WEBPACK FOOTER //
// src/screens/Question.vue